import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "./Auth";

const AppleAuthCallback = () => {
   const [status, setStatus] = useState("processing");
   const [message, setMessage] = useState("Processing your Apple login...");
   const navigate = useNavigate();

   useEffect(() => {
      const handleCallback = async () => {
         // Get query parameters from URL
         const queryParams = new URLSearchParams(window.location.search);
         const code = queryParams.get("code");
         const state = queryParams.get("state");
         const idToken = queryParams.get("id_token");
         const user = queryParams.get("user");

         // If we don't have the necessary parameters, show an error
         if (!code || !idToken) {
            setStatus("error");
            setMessage("Invalid or incomplete authentication data received.");
            return;
         }

         try {
            // Determine if this is a signup or login based on the state parameter
            const isSignUp = state === "signup";
            const endpoint = `/api/public/auth/apple`;

            // Forward the Apple authentication data to your backend
            const response = await fetch(endpoint, {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
               },
               body: JSON.stringify({
                  authorization: {
                     code,
                     identityToken: idToken,
                     user: user ? JSON.parse(decodeURIComponent(user)) : {},
                  },
                  isSignUp,
               }),
            });

            const data = await response.json();

            if (!response.ok) {
               throw new Error(
                  data.error || data.message || "Authentication failed"
               );
            }

            // Save authentication data to localStorage
            localStorage.setItem("token", data.token);
            localStorage.setItem("username", data.username);
            localStorage.setItem("userId", data.userId);
            localStorage.setItem("isAdmin", data.isAdmin || false);

            // Show success message briefly
            setStatus("success");
            setMessage("Authentication successful! Redirecting...");

            // Redirect to public feed after a short delay
            setTimeout(() => {
               navigate("/");
            }, 1500);
         } catch (error) {
            console.error("Error processing Apple callback:", error);
            setStatus("error");
            setMessage(error.message || "Failed to complete authentication.");
         }
      };

      handleCallback();
   }, [navigate]);

   return (
      <div className="container py-5">
         <div className="row justify-content-center">
            <div className="col-md-6">
               <div className="card shadow border-0">
                  <div className="card-body p-5 text-center">
                     {status === "processing" && (
                        <>
                           <LoadingSpinner />
                           <h4 className="mt-4">Processing Your Sign In</h4>
                           <p className="text-muted">
                              Please wait while we complete your
                              authentication...
                           </p>
                        </>
                     )}

                     {status === "success" && (
                        <>
                           <div className="mb-4 text-success">
                              <i
                                 className="bi bi-check-circle-fill"
                                 style={{ fontSize: "4rem" }}
                              ></i>
                           </div>
                           <h4>Authentication Successful!</h4>
                           <p>{message}</p>
                        </>
                     )}

                     {status === "error" && (
                        <>
                           <div className="mb-4 text-danger">
                              <i
                                 className="bi bi-exclamation-circle-fill"
                                 style={{ fontSize: "4rem" }}
                              ></i>
                           </div>
                           <h4>Authentication Failed</h4>
                           <p className="text-danger">{message}</p>
                           <button
                              className="btn btn-primary mt-3"
                              onClick={() => navigate("/login")}
                           >
                              Return to Login
                           </button>
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default AppleAuthCallback;
